import angular from 'angular';
import uiRouter from 'angular-ui-router';
import authComponent from './auth.component';
import Login from './login/login';

const authModule = angular.module('auth', [
    uiRouter,
    Login
])

.config(($stateProvider) => {
        "ngInject";
        $stateProvider
            .state('auth', {
                url: '/{locale}/auth',
                views: {
                    'navbar@': {
                        template: '<navbar></navbar>'
                    },
                    'main@': {
                        template: '<auth></auth>'
                    },
                    'footer@': {
                        template: '<footer></footer>'
                    }
                }
            });
    })
    .component('auth', authComponent)
    .name;

export default authModule;


// WEBPACK FOOTER //
// ./client/app/routes/auth/auth.js